// SearchResults.js
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { functions, httpsCallable } from './firebaseConfig'; // Ensure this import is correct
import BookmarkCard from './bookmakrCard';  // Ensure correct spelling of the import

function SearchResults() {
    const [searchParams] = useSearchParams();
    const searchQuery = searchParams.get('query');
    const [bookmarks, setBookmarks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const collectionIds = [
        32680330, 25118310, 25222528, 25118311, 25165934,
        25360841, 25360844, 25165940, 25118314, 25118312, 25165937
    ];

    useEffect(() => {
        if (searchQuery) {
            fetchBookmarks(searchQuery);
        } else {
            setLoading(false);
        }
    }, [searchQuery]);

    const fetchBookmarks = async (query) => {
        setLoading(true);
        const searchBookmarksFn = httpsCallable(functions, 'searchBookmarks');
        try {
            const result = await searchBookmarksFn({ collectionIds, query });
            const allBookmarks = result.data || [];
            setBookmarks(allBookmarks);
            setLoading(false);
            if (allBookmarks.length === 0) {
                setError("No bookmarks found for the given search query."); // Set error message for no bookmarks
            } else {
                setError(''); // Clear error if bookmarks are found
            }
        } catch (err) {
            setError(`Failed to fetch bookmarks: ${err.message}`);
            setLoading(false);
            console.error('Error fetching bookmarks:', err);
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error && bookmarks.length === 0) return (
        <div className="container mx-auto text-center p-10">
            <div className="card bg-neutral text-neutral-content">
                <div className="card-body items-center text-center">
                    <h2 className="card-title">🔍 Oops!</h2>
                    <p>{error}</p>
                    <p>Try searching a different keyword! 🔄</p>
                </div>
            </div>
        </div>
    );

    return (
        <div className="flex flex-wrap justify-center">
            {bookmarks.map((bookmark) => (
                <BookmarkCard
                    key={bookmark._id}
                    title={bookmark.title}
                    imageUrl={bookmark.cover}
                    description={bookmark.excerpt}
                    link={bookmark.link}
                    created={bookmark.created}
                />
            ))}
        </div>
    );
}

export default SearchResults;